import React, { useState, forwardRef, useEffect } from 'react'
import Modal from "react-bootstrap/Modal";
import { formatDate, CheckNull } from '../../utils/Validate'
import FetchData, { CreateEntry, GetOne, GetList, UpdatePutEntry, DeleteEntry } from '../../providers/dataProvider'
import urls from '../../constants';
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { PriceFormat, FormatValueDecimal, CurrencyConvertion } from "../../utils/Validate"

const AddForeCastItem = ({ showForecast, setOpenForecast, openForecast, currentForecast, currentQuotation, setQuotationData, currencyDetail, setCheckedRows, checkedRows }) => {
    const [forecastItemQuote, setForecastItemQuote] = useState({})
    const [productConfigVariant, setProductConfigVariant] = useState([]);
    const [productVariant, setProductVariant] = useState([]);
    const [quoteItem, setQuoteItem] = useState({})
    const [checkedCells, setCheckedCells] = useState({});
    const [editedValues, setEditedValues] = useState({});
    const [openNextModal, setOpenNextModal] = useState(false);
    const [forecastDate, setForecastDate] = useState("");
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const [show, setShow] = useState(false);
    const [forecastShow, setForecastShow] = useState(false);
    const [errorShow, setErrorShow] = useState({
        show: false,
        errorMessage: "",
    });
     const [createMsg, setCreateMsg] = useState(null)
     const [quoteProductItem, setQuoteProductItem] = useState({})
     const [forecastedData, setForecastedData] = useState([]);
    const [remainingData, setRemainingData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
   const [selectedLine, setSelectedLine] = useState(null)
   const [dateError, setDateError] = useState("")
  const formatDateForInput = (date) => {
    if (!date) return "";

    const dt = new Date(date);
    if (Number.isNaN(dt.getTime())) return "";

    const year = dt.getFullYear();
    const month = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
const handleNext = () => {

  const hasInvalidQty = Object.keys(checkedRows).some((key) => {

    if (!checkedRows[key]) return false;

    const qty =
      editedValues[`${key}-Quantity`] ??
      remainingData?.find(
        (item) =>
          String(item.quoteProductItemId) === String(key)
      )?.remainingQuantity ??
      productItems?.find(
        (item) => String(item.id) === String(key)
      )?.productItemVariants?.find(
        (v) => v.variantName === "Quantity"
      )?.variantValue;

    return !qty || Number(qty) <= 0;
  });

  if (hasInvalidQty) {
    toast.error("Quantity should be greater than 0");
    return;
  }

  if (!hasChanges) {
    toast.error("No changes detected");
    return;
  }

  setOpenForecast(false);
  setOpenNextModal(true);
  setHasChanges(false);
};
    useEffect(() => {
    if (currentForecast?.quotationId) {
        GetOne("quotation", { id: currentForecast.quotationId }, setQuoteItem)
    }

    if (currentForecast?.quoteProductItemId) {
        GetList(
        "forecastItemQuoteProduct",
        { quoteProductItemId: currentForecast.quoteProductItemId },
        setQuoteProductItem
        )
    }
    }, [currentForecast])
    const { data: productVariants, loading: productVariantsLoading, error: productVariantsError } = FetchData("productsvariants", { id: currentForecast?.productGroupId });
    
    const selectedProduct = quoteItem?.data?.products?.find(
      (p) => p?.id === currentForecast?.quoteProductId
    );
    useEffect(() => {
        if (!productVariants?.length) return;

        const activeVariants = productVariants.filter(
          (item) => item?.isActive === true
        );

        const subgroupVariants = activeVariants.filter(
          (item) =>
            String(item?.productSubGroupId) ===
            String(selectedProduct?.productSubGroupId)
        );

        const defaultVariants = activeVariants.filter(
          (item) =>
            item?.productSubGroupId === 0 ||
            item?.productSubGroupId === null
        );
        const nextVariants =
          subgroupVariants.length > 0
            ? subgroupVariants
            : defaultVariants.length > 0
              ? defaultVariants
              : activeVariants;

        setProductVariant(nextVariants);
        setProductConfigVariant(nextVariants);
    }, [productVariants, currentForecast, selectedProduct]);

const filteredVariants = React.useMemo(() => {
  const uniqueNames = new Set();
  return productConfigVariant?.filter((item) => {
    const isRequired =
      item.groupId === urls.NOMINAL_GROUP_ID ||
      (item.groupId === urls.PRICE_GROUP_ID &&
        item.variantId === urls.QUANTITY_VARIANT_ID);

    if (!isRequired) return false;

    if (uniqueNames.has(item.variantName)) return false;

    uniqueNames.add(item.variantName);
    return true;
  });
}, [productConfigVariant]);

    const filteredVariantsForecasted = productConfigVariant?.filter((item) => {
    if (item.variantId === urls?.QUANTITY_VARIANT_ID) return true;
    return false;
});

    const handleCheckboxChange = (rowIndex, variantName) => {
      setHasChanges(true)
        const key = `${rowIndex}-${variantName}`;

        setCheckedCells((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

  const handleValueChange = (quoteProductItemId, variantName, value) => {

    if (value === "") {
      setEditedValues((prev) => ({
        ...prev,
        [`${quoteProductItemId}-${variantName}`]: value
      }));
      return;
    }

    if (variantName === "Quantity") {

      const enteredValue = Number(value);

      const totalAllowed = remainingData.reduce((sum, item) => {
        return sum + (Number(item.remainingQuantity) || 0);
      }, 0);

      let otherTotal = 0;

      Object.keys(editedValues).forEach((key) => {

        if (!key.endsWith("-Quantity")) return;

        const rowId = key.replace("-Quantity", "");

        if (String(rowId) !== String(quoteProductItemId)) {
          otherTotal += Number(editedValues[key]) || 0;
        }
      });

      const finalTotal = otherTotal + enteredValue;

      if (finalTotal > totalAllowed) {
        return;
      }
    }

    setHasChanges(true);

    setEditedValues((prev) => ({
      ...prev,
      [`${quoteProductItemId}-${variantName}`]: value
    }));
  };

    const handleDateValueChange = (key, value) => {

    setEditedValues((prev) => ({
      ...prev,
      [key]: value
    }));

    setHasChanges(true);
  };

  const handleRowCheckboxChange = (id) => {
    setHasChanges(true)
    setCheckedRows((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

const handleSubmitForecast = () => {

  if (!forecastDate) {
    setDateError("Forecast date is required");
    return;
  }

  setDateError("");

  const groupedItems = {};

  forecastedData.forEach((forecast) => {

    const qpiId = forecast.quoteProductItemId;

    if (!groupedItems[qpiId]) {
      groupedItems[qpiId] = [];
    }

    const product = productItems.find(
      (p) => String(p.id) === String(qpiId)
    );

    forecast.lines.forEach((line, index) => {

      const qtyKey =
        `forecast-${qpiId}-${line.id}-Quantity`;

     const dateKey = line.forecastId
  ? `forecast-${line.forecastId}-Date`
  : `forecast-new-${qpiId}-Date`;

      const finalQty =
        editedValues[qtyKey] !== undefined
          ? Number(editedValues[qtyKey])
          : Number(line.expectedQuantity || 0);

          const editedDate = editedValues[dateKey];

const finalDate =
  editedValues[dateKey] !== undefined
    ? new Date(
        editedValues[dateKey]
      ).toISOString()
    : line.expectedDate;

      groupedItems[qpiId].push({
        id: line.id,
        quoteProductItemId: qpiId,
        expectedDate: finalDate,
        expectedQuantity: finalQty,
        expectedAmount:
          finalQty * Number(product?.unitPrice || 0),
        revisionNo:
          line.revisionNo || index,
        histories: [
          {
            id: 0,
            forecastedDate: finalDate
          }
        ]
      });

    });

  });

  remainingData.forEach((item, index) => {

    const qpiId = item.quoteProductItemId;

    if (!checkedRows[qpiId]) return;

    if (!groupedItems[qpiId]) {
      groupedItems[qpiId] = [];
    }

    const qty =
      editedValues[`${qpiId}-Quantity`] !== undefined
        ? Number(
            editedValues[`${qpiId}-Quantity`]
          )
        : Number(item.remainingQuantity || 0);

    const product = productItems.find(
      (p) => String(p.id) === String(qpiId)
    );
    const formattedDate =
      new Date(forecastDate).toISOString();

    groupedItems[qpiId].push({
      id: 0,
      quoteProductItemId: qpiId,
      expectedDate: formattedDate,
      expectedQuantity: qty,
      expectedAmount:
        qty * Number(product?.unitPrice || 0),
      revisionNo: index + 100,
      histories: [
        {
          id: 0,
          forecastedDate: formattedDate
        }
      ]
    });

  });

  const items = Object.keys(groupedItems).map(
    (id) => ({
      quoteProductItemId: Number(id),
      lines: groupedItems[id]
    })
  );

  const payload = {
    createdBy: userProfile?.identityId,
    quoteProductId:
      currentForecast?.quoteProductId,
    items
  };

  UpdatePutEntry(
    "forecastProductItem",
    payload,
    () => {

      setEditedValues({});
      setCheckedRows({});
      setForecastDate("");

    },
    setCreateMsg,
    "Updated successfully",
    "Update failed"
  );

};
const handleDelete = (item, line) => {

      DeleteEntry(
        "forecastProductItemDelete",
        {
          quoteProductId: item?.quoteProductId,
          forecastId: line?.forecastId
        },
        setCreateMsg,
        "Deleted successfully",
        "Delete failed"
      );
}

useEffect(() => {
  if (!createMsg) return;

  if (createMsg?.status === 400 || createMsg?.status === 404) {
    const errorMessage =
      createMsg?.successData ||
      createMsg?.message ||
      "Something went wrong";
    setErrorShow({
      show: true,
      errorMessage: errorMessage,
    });

    return;
  }

  if (createMsg?.message === "Updated successfully") {
    setOpenForecast(true);
    setOpenNextModal(false);
    setHasChanges(false)
    resetForecastState();
     if (currentForecast?.quoteProductId) {
      GetList("forecast", { quoteId: currentQuotation?.id }, setQuotationData);

      GetList(
        "forecastProductView",
        {
          id: currentForecast.quoteProductId,
          View: "Forecasted",
        },
        (res) => {
          setForecastedData(res?.data || []);
        }
      );
    }
  }

  if (createMsg?.message?.includes("Deleted successfully")) {
    setOpenForecast(false);
    setOpenNextModal(false);
    setShow(true);
    setHasChanges(false)

    if (currentForecast?.quoteProductId) {
      GetList("forecast", { quoteId: currentQuotation?.id }, setQuotationData);

      GetList(
        "forecastProductView",
        {
          id: currentForecast.quoteProductId,
          View: "Forecasted",
        },
        (res) => {
          setForecastedData(res?.data || []);
        }
      );
    }
  }

}, [createMsg]);

const SuccessDoneClick = () => {
    setShow(false); 
    setCreateMsg(null);
    setOpenForecast(false);
    setOpenNextModal(false);
    resetForecastState();
};
    const ErrorDoneClick = () => {
        setErrorShow({
            show: false,
            errorMessage: "",
        });
    };

const resetForecastState = () => {
    setCheckedRows({});
    setEditedValues({});
    setOpenNextModal(false);
    setForecastDate("");
};

useEffect(() => {
  if (!quoteProductItem?.data?.lines) return;

  const initialChecked = {};
  const initialValues = {};

  quoteProductItem.data.lines.forEach((line) => {
    const index = line.revisionNo;

    initialChecked[index] = true; 
    initialValues[`${index}-Quantity`] = line.expectedQuantity; 
  });

  setCheckedRows(initialChecked);
  setEditedValues(initialValues);

}, [quoteProductItem]);

const [forecasted, setForecasted] = useState([])
const [isEditMode, setIsEditMode] = useState(false);
const [showRemaining, setShowRemaining] = useState(false);
useEffect(() => {
  if (!currentForecast?.quoteProductId) return;

  GetList(
    "forecastProductView",
    {
      id: currentForecast.quoteProductId,
      View: "Forecasted",
    },
    (res) => {
      setForecastedData(res?.data || []);
    }
  );

  setShowRemaining(false);
  setIsEditMode(false);

   GetList(
    "forecastProductView",
    {
      id: currentForecast.quoteProductId,
      View: "Remaining",
    },
    (res) => {
      setRemainingData(res?.data || []);
    }
  );

}, [currentForecast, createMsg]);

const forecastData = forecasted?.data?.[0];

const productItems =
  quoteItem?.data?.products?.find(
    (p) => p.id === currentForecast?.quoteProductId
  )?.productItems || [];

 const handleAddClick = () => {
  setShowRemaining(true);

  GetList(
    "forecastProductView",
    {
      id: currentForecast.quoteProductId,
      View: "Remaining",
    },
    (res) => {
      setRemainingData(res?.data || []);
    }
  );
};

const hasForecast = forecastedData.length > 0;
const hasRemaining = remainingData.length > 0;
useEffect(() => {
  setCheckedRows({});
}, [remainingData]);

const handleSelectAll = (e) => {
  const isChecked = e.target.checked;

  const updated = {};
  remainingData.forEach((item) => {
    updated[item.id] = isChecked;
  });

  setCheckedRows(updated);
};

const handleRowCheck = (id) => {
  setHasChanges(true)
  setCheckedRows((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
};


const [totalQty, setTotalQty] = useState(0);
const [totalAmount, setTotalAmount] = useState(0);

useEffect(() => {

  let qty = 0;
  let amount = 0;

  if (hasForecast) {

    qty += Number(selectedLine?.group?.totalQuantity || 0);

    amount += Number(selectedLine?.group?.totalAmount || 0);

    remainingData.forEach((item) => {

      const qpiId = item.quoteProductItemId;

      if (!checkedRows[qpiId]) return;

      const itemQty =
        editedValues[`${qpiId}-Quantity`] !== undefined
          ? Number(editedValues[`${qpiId}-Quantity`])
          : Number(item.remainingQuantity || 0);

      const product = productItems.find(
        (p) => String(p.id) === String(qpiId)
      );

      qty += itemQty;

      amount += itemQty * Number(product?.unitPrice || 0);
    });

  } else {

    productItems.forEach((item) => {

      const isChecked = checkedRows?.[item.id];

      if (!isChecked) return;

      const quantityVariant = item?.productItemVariants?.find(
        (v) =>
          String(v.variantId) ===
          String(urls?.QUANTITY_VARIANT_ID)
      );

      const itemQty =
        editedValues[`${item.id}-Quantity`] ??
        quantityVariant?.variantValue ??
        0;

      const unitPrice = Number(item?.unitPrice || 0);

      qty += Number(itemQty);

      amount += Number(itemQty) * unitPrice;
    });
  }

  setTotalQty(qty);
  setTotalAmount(amount);

}, [
  hasForecast,
  remainingData,
  checkedRows,
  editedValues,
  productItems,
  selectedLine
]);
const handleQuantityChange = (e, item, rowIndex) => {
  setHasChanges(true)
  const value = e.target.value;

  const rowKey = `${item.id}-${rowIndex}`;

  setEditedValues((prev) => ({
    ...prev,
    [`${rowIndex}-Quantity`]: value,
    [`${rowKey}-Quantity`]: value
  }));
};

  const getVariant = (quoteProductItemId) => {
    return productItems.find(
      (item) => item.id === quoteProductItemId
    );
  };

const handleForecastChange = (key, value) => {
  setHasChanges(true)
  setEditedValues((prev) => ({
    ...prev,
    [key]: value,
  }));
};
const [editingRow, setEditingRow] = useState(null);
  const allSelected =
    productItems.length > 0 &&
    productItems.every((item) => checkedRows[item.id] === true);
    const [editRowIndex, setEditRowIndex] = useState(null);

    const quotedAmount = productItems.reduce((sum, item) => {

      const quantityVariant = item?.productItemVariants?.find(
        (v) =>
          String(v.variantId) ===
          String(urls?.QUANTITY_VARIANT_ID)
      );

      const qty = Number(quantityVariant?.variantValue || 0);

      return sum + qty * Number(item?.unitPrice || 0);

    }, 0);

    const forecastedAmount = forecastedData.reduce(
      (sum, forecast) => {

        const product = productItems.find(
          (p) =>
            String(p.id) ===
            String(forecast.quoteProductItemId)
        );

        const lineTotal =
          forecast?.lines?.reduce((lineSum, line) => {

            const qty = Number(
              line?.expectedQuantity || 0
            );

            return (
              lineSum +
              qty * Number(product?.unitPrice || 0)
            );

          }, 0) || 0;

        return sum + lineTotal;

      },
      0
    );

    const balanceAmount =
      quotedAmount - forecastedAmount;
    return(
        <>
        <Modal size='sm' show={openForecast} className='forecastRightSideModalPopup drawer right-align'>
            <Modal.Header>
                <h5 className="modal-title">{currentForecast?.productGroupName} - {currentForecast?.productName}</h5>
                <i className="fas fa-times" onClick={() => {
                    setOpenForecast(false);
                    setHasChanges(false)
                    resetForecastState();   
                }}></i>
            </Modal.Header>
      <Modal.Body>
        <div className="row modal-row mt-2">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-4  quoted-col">
              <div className='d-flex gap-2 align-items-center'>
              <i class="fas fa-file-invoice mr-2"></i>
              <div>
                <p>Quoted</p>
                <h4>{FormatValueDecimal(
                    CurrencyConvertion(
                      quotedAmount,
                      currentQuotation?.row?.conversionRate,
                      currencyDetail
                    )
                  )}</h4>

              </div>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-4  forecasted-col">
              <div className='d-flex gap-2 align-items-center'>
                <i class="fas fa-chart-line mr-2"></i>
                <div>
                  <p>Forecasted</p>
                  <h4>{FormatValueDecimal(
                      CurrencyConvertion(
                        forecastedAmount,
                        currentQuotation?.row?.conversionRate,
                        currencyDetail
                      )
                    )}</h4>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-4  balance-col">
              <div className='d-flex gap-2 align-items-center'>
                <i class="fas fa-coins mr-2"></i>
                <div>
                  <p>Balance</p>
                  <h4>{FormatValueDecimal(
                      CurrencyConvertion(
                        balanceAmount,
                        currentQuotation?.row?.conversionRate,
                        currencyDetail
                      )
                    )}</h4>
                </div>
              </div>
            </div>       
        </div>
        <div className="table-responsive">
          {!hasForecast && remainingData?.length > 0 && (
           <div className="mb-2 text-end">
          <button
            className="btn add-forecast mt-2"
            onClick={handleAddClick}  >
            New Forecast
          </button>
        </div>
        )}
    {hasForecast && !showRemaining && (
      <>
        <div className='forecasted-section'>

          <div className='d-flex justify-content-between align-items-center w-100 mt-4 '>
            <h5>Forecasted Items</h5>

            {remainingData?.length > 0 && (
              <div className="mb-2 text-end">
                <button
                  className="btn mt-2 mb-3"
                  onClick={handleAddClick}
                >
                  New Forecast
                </button>
              </div>
            )}
          </div>

          {(() => {

            const mergedForecasts = [];
            forecastedData?.forEach((item) => {

              item?.lines?.forEach((line) => {

                const existingForecast = mergedForecasts.find(
                  (forecast) =>
                    forecast.forecastId === line.forecastId
                );

                if (existingForecast) {

                  existingForecast.totalQuantity +=
                    Number(line.expectedQuantity || 0);

                  existingForecast.totalAmount +=
                    Number(item.forecastedAmount || 0);

                  existingForecast.items.push({
                    item,
                    line,
                  });

                } else {

                  mergedForecasts.push({
                    forecastId: line.forecastId,
                    expectedDate: line.expectedDate,
                    totalQuantity: Number(
                      line.expectedQuantity || 0
                    ),
                    totalAmount: Number(
                      item.forecastedAmount || 0
                    ),
                    items: [
                      {
                        item,
                        line,
                      },
                    ],
                  });

                }

              });

            });

            return (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    {filteredVariantsForecasted?.map(
                      (v, i) => (
                        <th key={i}>
                          {v.variantName}
                        </th>
                      )
                    )}
                    <th>Forecasted amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {mergedForecasts?.map(
                    (group, groupIndex) => {

                      const firstItem =
                        group.items?.[0]?.item;

                      const firstLine =
                        group.items?.[0]?.line;

                      const today = new Date();

                      today.setHours(0, 0, 0, 0);

                      const forecastDate = new Date(
                        firstLine?.expectedDate
                      );

                      forecastDate.setHours(
                        0,
                        0,
                        0,
                        0
                      );

                      const isExpired =
                        forecastDate < today;

                      const isMerged =
                        group.items.length > 1;

                      return (
                        <tr
                          key={groupIndex}
                          style={{
                            backgroundColor:
                              isExpired
                                ? "#ecdddd"
                                : "",
                          }}
                        >
                          <td>
                            {formatDate(
                              firstLine?.expectedDate
                            )}
                          </td>

                          {filteredVariantsForecasted.map(
                            (
                              variant,
                              colIndex
                            ) => {

                              let value = "-";

                              if (
                                variant.variantName ===
                                "Quantity"
                              ) {

                                value =
                                  isMerged
                                    ? group.totalQuantity
                                    : firstLine?.expectedQuantity;

                              } else {

                                const matchedVariant =
                                  firstItem?.productItemVariants?.find(
                                    (v) =>
                                      String(
                                        v.variantId
                                      ) ===
                                      String(
                                        variant.variantId
                                      )
                                  );

                                value =
                                  matchedVariant?.variantValue;
                              }
                              return (
                                <td key={colIndex}>
                                  <span>
                                    {value || "-"}
                                  </span>
                                </td>
                              );

                            }
                          )}
                          <td>
                            {group.totalAmount.toFixed(2)}
                          </td>

                          <td>

                            <i
                              className="far fa-edit"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {

                                const rowKey =
                                  `${group.forecastId}-${firstLine?.id}`;

                                const editKey =
                                  `forecast-${firstItem?.quoteProductItemId}-${firstLine?.id}-Quantity`;
                                const dateKey = firstLine?.forecastId
                                  ? `forecast-${firstLine?.forecastId}-Date`
                                  : `forecast-new-${firstItem?.quoteProductItemId}-Date`;

                                setEditedValues(
                                  (prev) => ({
                                    ...prev,
                                    [editKey]:
                                      firstLine?.expectedQuantity,
                                    [dateKey]: formatDateForInput(
                                      firstLine?.expectedDate
                                    ),
                                  })
                                );

                                setForecastDate(
                                  formatDateForInput(
                                    firstLine?.expectedDate
                                  )
                                );
                                setDateError("");
                                setSelectedLine({
                                  qpiId:
                                    firstItem?.quoteProductItemId,
                                  line: firstLine,
                                  group: group,
                                });

                                setEditRowIndex(
                                  rowKey
                                );

                                setOpenForecast(
                                  false
                                );

                                setOpenNextModal(
                                  true
                                );

                              }}
                            />

                            <i
                              className="far fa-trash-alt ml-2"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleDelete(
                                  firstItem,
                                  firstLine
                                )
                              }
                            />

                          </td>

                        </tr>
                      );

                    }
                  )}

                </tbody>

              </table>
            );

          })()}

        </div>
      </>
    )}
    </div>
      </Modal.Body>
        </Modal>      
        <Modal
          size="md"
          show={showRemaining}
          className="forecastRightSideModalPopup drawer right-align"
        >
          <Modal.Body className="p-0">          
        {showRemaining && remainingData?.length > 0 && (
          <>
          <div className='d-flex align-items-baseline remaining-section'>
          <i
              className="fas fa-arrow-left mr-3"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowRemaining(false);
                setOpenForecast(true);
                 setCheckedRows({});
                setEditedValues({});
                setForecastDate("");
                setSelectedLine(null)
                setTotalQty(0)
                setTotalAmount(0)
              }}
            />
           <h5>Remaining Items</h5>
           </div>
           <div className="p-3">
          <table className="table table-bordered remaining-table">
            <thead>
              <tr>

                {/* ✅ SELECT ALL */}
                <th>
                 <div className='d-flex align-items-center justify-content-center'>
                  <input
                  type="checkbox"
                  checked={
                    remainingData?.length > 0 &&
                    remainingData.every(
                      (item) => checkedRows[item.quoteProductItemId]
                    )
                  }
                  onChange={(e) => {
                    const isChecked = e.target.checked;

                    const updated = {};

                    remainingData.forEach((item) => {
                      updated[item.quoteProductItemId] = isChecked;
                    });
                    setHasChanges(true)
                    setCheckedRows(updated);
                  }}
                />
                </div>
                </th>
                {filteredVariants?.map((variant, index) => (
                  <th key={index}>{variant.variantName}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {remainingData?.map((item, index) => {
              const rowKey = item.quoteProductItemId; 
                const isChecked = !!checkedRows[rowKey];
                return (
                  <tr key={rowKey}>
                    <td className="text-center">
                      <input
                      type="checkbox"
                      checked={!!checkedRows[rowKey]}
                     onChange={() => {
                      setCheckedRows((prev) => {
                        const updated = {
                          ...prev,
                          [rowKey]: !prev[rowKey],
                        };

                        setHasChanges(Object.values(updated).some(Boolean));

                        return updated;
                      });
                    }}
                    />
                    </td>

                    {filteredVariants?.map((variant, colIndex) => {
                      const key = `${rowKey}-${variant.variantName}`;

          const productMatch = productItems?.find(
            (p) => String(p.id) === String(rowKey)
          );

          const matchedVariant = productMatch?.productItemVariants?.find(
            (v) => v.variantId === variant.variantId
          );

          const value =
            editedValues[key] ??
            (variant.variantName === "Quantity"
              ? item.remainingQuantity
              : matchedVariant?.variantValue) ?? "";

                      return (
                        <td key={colIndex}>
                      {variant.variantName === "Quantity" && isChecked ? (                      
                          <input
                            autoFocus
                            value={value}
                            onChange={(e) =>
                              handleValueChange(
                                item.quoteProductItemId,
                                variant.variantName,
                                e.target.value
                              )
                            }
                            onBlur={() => setEditingRow(null)}
                          />                                          
                      ) : (
                        <span>{value || "-"}</span>
                      )}
                    </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
            </div>
          </>
          )}
          <div className="pr-3 text-end">
            {hasChanges && (
          <button className="btn save-btn mb-2" onClick={handleNext}>
              Next
            </button>
            )}
          </div>
          </Modal.Body>
        </Modal>
         <Modal
          size="md"
          show={openNextModal}
          className="forecastRightSideModalPopup drawer right-align"
        >
         
          <Modal.Body className="p-0">
            <div className='d-flex mb-2 align-items-baseline forecast-summary-section'>
             <i
              className="fas fa-arrow-left mr-3"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpenNextModal(false);
                // setHasChanges(true);
                 setCheckedRows({});
                  setEditedValues({});
                  setForecastDate("");
                  setSelectedLine(null)
                  setTotalQty(0)
                setTotalAmount(0)
                if(remainingData?.length){
                setShowRemaining(true);
                }
                else{
                  setOpenForecast(true)
                }
              }}
            />
            <h5>Forecast summary</h5>
            </div>
            <div className="p-3">
            <div style={{ marginBottom: "15px" }}>
              <label>
                <b>Forecast Date:</b>
              </label>
                <input
                type="date"
                className="form-control"
                min={new Date().toISOString().split("T")[0]}
                value={(() => {
                  const dateKey = selectedLine?.line?.forecastId
                    ? `forecast-${selectedLine?.line?.forecastId}-Date`
                    : `forecast-new-${selectedLine?.qpiId}-Date`;

                  return editedValues[dateKey] || forecastDate || "";
                })()}
                onChange={(e) => {

                  const value = e.target.value;
                   const dateKey =
                  selectedLine?.line?.forecastId
                    ? `forecast-${selectedLine?.line?.forecastId}-Date`
                    : `forecast-new-${selectedLine?.qpiId}-Date`;
                  setForecastDate(e.target.value),
                  handleDateValueChange(
                    dateKey,
                    value
                  );

                  setDateError(
                    value ? "" : "Forecast date is required"
                  );
                }}
              />
              {dateError && (
                <small className="text-danger">
                  {dateError}
                </small>
              )}
            </div>

            <div style={{ marginTop: "10px" }}>
              <p>
                <b>Forecasted Quantity:</b> {totalQty}
              </p>

              <p>
                <b>Forecasted Amount:</b>{" "}
                {totalAmount.toFixed(2)}
              </p>
            </div>

            <Row className="text-end">
              <Col>
                <button
                  type="button"
                  className="btn save-btn"
                  onClick={handleSubmitForecast}
                >
                  Submit
                </button>
              </Col>
            </Row>
            </div>

          </Modal.Body>
        </Modal>
        <SaveSuccessModel
            createMsg={createMsg}
            setCreateMsg={setCreateMsg}
            setShow={setShow}
            show={show}
            SuccessDoneClick={SuccessDoneClick}
        />
        <ErrorMessage
            Show={errorShow?.show}
            errorMessage={errorShow?.errorMessage}
            ErrorDoneClick={ErrorDoneClick}
        />
</>
    )
}

export default AddForeCastItem
